import ErrorStackParser from 'error-stack-parser'
import objectToFormData from 'object-to-formdata'
import debounce from 'lodash.debounce'

const url = `${PUBLIC_PATH}errors/js`
const consoleMinLevel = (process.env.NODE_ENV === 'production' ? 300 : 0)
const serverMinLevel = 300

const logLevels = {
  'DEBUG': 100,
  'INFO': 200,
  'NOTICE': 250,
  'WARNING': 300,
  'ERROR': 400,
  'CRITICAL': 500,
  'ALERT': 550,
  'EMERGENCY': 600,
}

class Logger {
  constructor() {
    for (let name in logLevels) {
      this[name.toLowerCase()] = function() {
        this.addLogRecord.apply(this, [name, ...arguments])
      }
    }

    this.logs = []
    this.attachEventListeners()
  }

  attachEventListeners() {
    window.addEventListener('beforeunload', () => {
      if (this.logs.length) {
        // send some stuff to server
      }
    })

    window.addEventListener('error', (event) => {
      this.addErrorRecord(event.error)
    })

    // 'capture' listener, listen to missing images etc
    window.addEventListener('error', (event) => {
      if (event.target === window) {
        // these are handled by the previous listener
        return
      }

      const target = event.target
      const tagName = target.tagName

      if (tagName == 'IMG') {
        // missing image
        return this.addLogRecord('WARNING', `Missing image: ${target.src}`)
      }

      return this.addLogRecord('WARNING', `Missing asset in ${tagName}`)
    }, true)

    window.addEventListener('unhandledrejection', error => {
      // unhandled promise rejection
    })

    window.addEventListener('messageerror', error => {
      // failed to deserialize worker message
    })
  }

  getLevelFromName(name) {
    return logLevels[name.toUpperCase()]
  }

  addErrorRecord(error) {
    let stack = ErrorStackParser.parse(error)
      .map((item) => {
        return {
          column: item.columnNumber,
          line: item.lineNumber,
          file: item.fileName
        }
      })

    const context = {
      native: true,
      stack: stack,
    }

    this.addLogRecord('ERROR', `${error.name} ${error.message}`, context)
  }

  addLogRecord(levelName, message, context = {}) {
    if (typeof message === 'undefined' || ! message.length) {
      return
    }

    // add UA to context
    context.ua = window.navigator.userAgent

    const log = {
      level: levelName,
      message,
      context,
    }

    this.logToConsole(log)

    if (this.getLevelFromName(log.level) < serverMinLevel) {
      return
    }

    this.logs.push(log)
    this.sendToServer()
  }

  logToConsole(log) {
    if (this.getLevelFromName(log.level) < consoleMinLevel) {
      return
    }

    let methodName = log.level.toLowerCase()
    if (methodName == 'debug') {
      methodName = 'log'
    }

    if (typeof console === 'undefined') {
      return false
    } else if (console[methodName] !== undefined) {
      return console[methodName](log.message)
    } else if (console.log !== undefined) {
      return console.log(log.message)
    }
  }

  collectData() {
    return {logs: this.logs}
  }

  sendToServer = debounce(() => {
    if (navigator.sendBeacon) {
      // return this.sendBeacon()
    }

    const xmlhttp = new XMLHttpRequest()
    xmlhttp.open('POST', url);
    xmlhttp.setRequestHeader('Content-Type', 'application/json')
    xmlhttp.send(JSON.stringify(this.collectData()))

    this.logs = []
  }, 2000)

  sendBeacon() {
    const fd = objectToFormData(this.collectData())
    navigator.sendBeacon(url, fd)

    this.logs = []
  }
}

const logger = new Logger

export default logger



// WEBPACK FOOTER //
// ./resources/assets/front/js/shared/logger.js